<template>
  <load v-if="loading" message="Carregando Denúncias" />
  <div v-else class="row">
    <div class="col-md-12">
      <h1 v-if="nova_denuncia" class="h3 mb-3 text-gray-800">
        {{ $t("Cadastrar Denúncia") }}
      </h1>
      <h1 v-else class="h3 mb-3 text-gray-800">{{ $t("Denúncias") }}</h1>
      <!--Tabela-->
      <div class="row">
        <div class="col-md-12">
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div
                  v-if="!nova_denuncia"
                  class="animate__animated animate__fadeIn"
                >
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <button
                          class="btn btn-sm btn-primary"
                          @click="nova_denuncia = true"
                        >
                          <i class="fas fa-plus-square" />
                          {{ $t("Cadastrar") }}
                        </button>

                        <b-button-group v-if="!nova_denuncia">
                          <b-button
                            variant="outline-dark"
                            :class="viewFilterReport === true ? 'active' : ''"
                            @click="viewFilters"
                          >
                            <i class="fas fa-filter"></i>
                            {{ $t("Filtros") }}
                          </b-button>

                          <b-button variant="outline-dark" @click="print()">
                            <i class="fas fa-print"></i>
                          </b-button>
                          <b-button
                            variant="outline-dark"
                            @click="exportar()"
                            :title="$t('Exportar')"
                            v-b-tooltip.hover
                          >
                            <i class="fas fa-file-excel"></i>
                          </b-button>
                        </b-button-group>
                      </div>
                    </div>

                    <div class="col-12" v-if="viewFilterReport">
                      <form @submit.prevent="getDenuncias" ref="formFiltros">
                        <div class="row">
                          <div class="col-md-12 mb-2">
                            <label><b>Pesquisar</b></label>
                            <div class="input-group">
                              <b-input
                                placeholder="Pesquisar por: protocolo ou nome do técnico"
                                class="form-control search-input"
                                type="text"
                                v-model="search"
                                aria-describedby="input-search"
                                @keydown.enter.prevent="getDenuncias"
                              />
                            </div>
                          </div>

                          <form-calendar
                            v-model="data_inicio"
                            grid="4"
                            label="Data inicial"
                            :max-date="dataNow"
                          />

                          <form-calendar
                            v-model="data_fim"
                            grid="4"
                            label="Data final"
                            :required="verificaDataInicial"
                            :min-date="data_inicio"
                            :max-date="dataNow"
                          />

                          <form-select
                            v-model="filtroStatus"
                            grid="4"
                            label="Status"
                            :itens="status"
                            :loading="loadingStatus"
                            :disabled="loadingStatus"
                            multiple
                          />
                        </div>
                        <div
                          class="row pt-2 mb-4 px-0 d-flex justify-content-end"
                        >
                          <div class="col-auto px-2 text-right">
                            <button
                              class="btn btn-default btn-sm"
                              @click.prevent="viewFilterReport = false"
                            >
                              <i class="fas fa-times"></i>
                            </button>

                            <button
                              type="button"
                              class="btn btn-secondary btn-sm"
                              @click.prevent="limparFiltros()"
                            >
                              {{ $t("Limpar Filtros") }}
                            </button>
                            <button
                              class="btn btn-success btn-submit btn-sm"
                              data-style="zoom-in"
                              type="submit"
                            >
                              <i class="fas fa-chart-bar"></i>
                              {{ $t("Filtrar") }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <print-content>
                        <b-table
                          :fields="[
                            {
                              key: 'protocolo',
                              label: $t('Detalhes'),
                            },
                            {
                              key: 'tecnico',
                              label: $t('Técnico'),
                            },
                            {
                              key: 'data',
                              label: $t('Data'),
                            },
                            {
                              key: 'status_nome',
                              label: $t('Status'),
                            },
                            {
                              key: 'actions',
                              label: '',
                              class: 'text-right no-print',
                              thStyle: {
                                width: '95px',
                                minWidth: '95px',
                              },
                            },
                          ]"
                          :items="DenunciasList"
                          :responsive="true"
                          striped
                          hover
                          show-empty
                          small
                          outlined
                          stacked="xs"
                          table-class="mb-3"
                        >
                          <template v-slot:cell(protocolo)="data">
                            <strong
                              v-if="data.item.data_prevista"
                              class="badge badge-danger"
                            >
                              {{ data.item.msg_prazo }}
                            </strong>
                            <br v-if="data.item.data_prevista" />
                            Canal:
                            <strong>
                              {{ data.item.canal }}
                            </strong>

                            <br />
                            Denunciante:
                            <strong>
                              {{ data.item.quem_denunciou }}
                            </strong>
                            <br />
                            Protocolo:
                            <strong
                              v-html="
                                $options.filters.highlight(
                                  data.item.protocolo,
                                  search
                                )
                              "
                            >
                            </strong>

                            <br />
                            <small
                              class="d-block border p-2 rounded"
                              v-if="data.item.unidade_destino"
                            >
                              Encaminhado para:<br />
                              Técnico:
                              <b>{{ data.item.tecnico_destino }}</b>
                              <span class="d-block">
                                Unidade:
                                <b>{{ data.item.unidade_destino }}</b>
                              </span>
                            </small>
                          </template>
                          <template v-slot:cell(tecnico)="data">
                            <strong
                              v-html="
                                $options.filters.highlight(
                                  data.item.tecnico,
                                  search
                                )
                              "
                            >
                            </strong>
                          </template>
                          <template v-slot:cell(data)="data">
                            <small>
                              Criado em:
                              {{ data.item.data }}<br />
                              Atualizado em:
                              {{ data.item.atualizado }}
                            </small>
                          </template>
                          <template v-slot:cell(status_nome)="data">
                            <span
                              class="small"
                              v-html="data.item.status_nome"
                            ></span>
                          </template>
                          <template v-slot:cell()="data">
                            <button
                              @click="redirectDenuncia(data.item.id)"
                              class="px-2 mb-0 btn btn-sm btn-success"
                            >
                              <i class="mdi mdi-square-edit-outline" />
                            </button>
                          </template>
                          <template v-slot:empty="scope">
                            <div class="text-center my-5">
                              <img
                                :alt="$t('No results')"
                                class="mb-5"
                                src="/img/icons/robot.svg"
                                style="max-height: 165px"
                              />
                              <h3 class="bold">
                                {{ $t("No records found") }}
                              </h3>
                            </div>
                          </template>
                        </b-table>
                      </print-content>
                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="perPage"
                              v-on:change="getDenuncias"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            de
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>

                      <div class="box-btn-print no-print">
                        <b-button
                          v-if="!loading"
                          :title="$t('Visualizar e Imprimir')"
                          class="py-2"
                          size="sm"
                          type="button"
                          v-b-tooltip.hover
                          variant="primary"
                          @click="print()"
                        >
                          <i class="fas fa-print"></i>
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
                <NovoDenuncia v-else @voltar="nova_denuncia = false" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NovoDenuncia from "./Add";
export default {
  components: { NovoDenuncia },
  name: "Denuncias",
  metaInfo() {
    return {
      title: this.$i18n.t("Denuncias"),
    };
  },
  data() {
    return {
      nova_denuncia: false,
      TipoDenunciasList: [],
      DenunciasList: [],
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      filtroStatus: [],
      filtroDatas: [],
      loadingStatus: false,
      dataNow: moment().format("YYYY/MM/DD"),
    };
  },
  mounted() {
    this.getDenuncias();
    this.getStatus();
  },
  methods: {
    getDenuncias() {
      this.loading = true;

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }
      axios
        .get("api/dashboard/denuncias", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroDatas: this.filtroDatas,
            filtroStatus: this.filtroStatus,
          },
        })
        .then((response) => {
          this.DenunciasList = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getDenuncias();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/denuncias", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroDatas: this.filtroDatas,
            filtroStatus: this.filtroStatus,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getDenuncias();
      }
    },
    redirectDenuncia(id) {
      this.$router.push(`/dashboard/denuncias/edit/${id}`);
    },
    getStatus() {
      this.loadingStatus = true;
      axios
        .get(`api/dashboard/status/denuncias`)
        .then((response) => {
          this.status = response.data;
        })
        .finally(() => {
          this.loadingStatus = false;
        });
    },
    limparFiltros() {
      //   this.filtros = {};
      this.search = "";
      this.data_inicio = null;
      this.data_fim = null;

      this.filtroStatus = [];
      this.getDenuncias();
    },
  },
};
</script>
